<template>
  <wtFormRight>
    <!-- -TOOLBARS -->
    <template slot="toolbars">
      <Toolbars
        :objProps="objItem"
        :objPropsData="objItemData"
        :urlServices="urlServices"
        :primary_key="primary_key"
        :nameObjData="nameObjData"
        :requiredEndDt="requiredEndDt"
        :noDelete="noDelete"
      />
    </template>

    <!-- VIEW TABLE -->
    <template slot="table" v-if="showGrid">
      <QueueGrid @selectedQueue="objRowSelected = $event"></QueueGrid>
    </template>

    <!-- VIEW FORM -->
    <template slot="form" v-if="!showGrid">
      <b-form class="text-uppercase">
        <!-- Line 01 -->
        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="queue_description">Description</label>
            <input
              type="text"
              class="form-control"
              id="queue_description"
              v-model.trim="objItemData.description"
              @keyup="toUpperCase"
            />
          </div>
          <b-form-group
            v-if="!objItemData.url"
            label="Is Fifo?"
            class="col-md-6 wt-radio-boolean wt-checkbox-noback"
          >
            <b-form-radio
              v-model="objItemData.is_fifo"
              name="some-radios"
              value="Y"
              class="wt-multiselect-item noback"
              id="queue_is_fifo_y"
            >Yes</b-form-radio>
            <b-form-radio
              v-model="objItemData.is_fifo"
              name="some-radios"
              value="N"
              class="wt-multiselect-item noback"
              id="queue_is_fifo_n"
            >No</b-form-radio>
          </b-form-group>

          <div v-if="objItemData.url" class="form-group col-md-6">
            <label for="queue_is_fifo_readonly">Is Fifo?</label>
            <input
              type="text"
              class="form-control"
              id="queue_is_fifo_readonly"
              v-model.trim="objItemData.is_fifo"
              readonly
            />
          </div>
        </div>

        <div v-if="objItemData.url">
          <hr class="mt-0" />

          <div class="form-row">
            <div class="form-group col-md-12">
              <label>URL</label>
              <p class="read-only">{{objItemData.url}}</p>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-12">
              <label>URL_OLD</label>
              <p class="read-only">{{objItemData.url_old}}</p>
            </div>
          </div>
        </div>
      </b-form>
    </template>
  </wtFormRight>
</template>
<script>
/** RECURSOS DO VUE **/
import { baseApiUrl, baseApiPort } from "@/global";
import axios from "axios";

/* COMPONENTS - LAYOUT */
import wtFormRight from "@/components/forms/wtFormRight";
import Toolbars from "@/components/widgets/Toolbars";

/* COMPONENTS - PAGE */
import QueueGrid from "./QueueGrid";

export default {
  name: "Queue",

  /* COMPONENTS IN USE */
  components: { wtFormRight, Toolbars, QueueGrid },

  /* COMPUTED VARIABLES */
  computed: {
    showGrid() {
      return this.$store.state.layout.showGrid;
    },
    urlServicesStore() {
      return this.$store.state.urlServicesStore;
    },
    objShared() {
      return this.$store.state.objShared;
    },
    objSelected() {
      return this.$store.state.objSelected;
    },
    action() {
      return this.$store.state.action;
    }
  },

  /* VARIABLES */
  data: function() {
    return {
      /* Controls */
      urlServices: "streamline-ds/api/internal/queue",
      primary_key: "queue_id",

      /* Objects Page */
      objItem: {},
      objItemData: {},
      objRowSelected: {},
      nameObjData: "queue_data",
      requiredEndDt: false,
      noDelete: true
    };
  },

  /* METHODS */
  methods: {
    load(objItem) {
      this.$store.commit("setShowLoading", true);
      this.$store.commit("setShowGrid", false);

      const param = {};
      param[`${this.primary_key}`] = objItem[`${this.primary_key}`];
      const url = `${baseApiUrl}:${baseApiPort}/${this.urlServices}/find/`;

      axios.post(url, param).then(res => {
        this.objItem = res.data[0];
        this.objItemData = this.objItem[`${this.nameObjData}`];
        this.$store.commit("setShowLoading", false);
      });
    },
    toUpperCase() {
      this.objItemData.description = this.objItemData.description.toUpperCase();
    }
  },
  /* WATCH */
  watch: {
    objRowSelected() {
      this.load(this.objRowSelected);
      this.$store.commit("setAction", "modify");
    },
    objSelected() {
      if (this.urlServicesStore === this.urlServices) {
        if (Object.entries(this.objSelected).length === 0) {
          this.$emit("queueSelected", null);
        } else {
          this.$emit("queueSelected", this.objSelected.queue_data.description);
        }
      }
    },
    action() {
      if (this.urlServicesStore === this.urlServices) {
        if (this.action === "reset") {
          this.objItem = {};
          this.objItemData = {};
        }
      }
    }
  }
};
</script>